// Svelte action: render an element at the end of <body>, outside any transformed/overflow-clipped ancestor.
// Used by the map's bottom sheet so `position: fixed` is relative to the viewport on every page.
export function portal(node: HTMLElement) {
  document.body.appendChild(node);
  return { destroy: () => node.remove() };
}
